/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import {
    object, func, string, shape, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import memberDucks from '../../../../../../../../state/ducks/Member/ducks';
import { getFeatureFlags, getPresentationFamily } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const {
    common: {
        commonSelectors,
    },
} = memberDucks;
const styles = (theme) => ({
    signInIcon: {
        height: '23px',
        width: '23px',
        pointerEvent: 'none',
        display: 'inline-block',
    },
    signIn: {
        fontSize: 16,
        fontWeight: 'bold',
        display: 'block',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        backgroundColor: '#F4F2F7',
        padding: '0px 16px',
        webkitBoxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
        mozBoxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
        boxShadow: '0px -4px 3px rgba(100, 100, 100, 0.21)',
        '&:first-child': {
            borderRadius: 0,
        },
        '& .MuiCollapse-entered': {
            paddingBottom: '12px',
        },
    },
    panelDetails: {
        fontSize: '16px',
        lineHeight: '19px',
        fontWeight: 500,
        padding: '8px 0px',
        '& a': {
            textDecoration: 'none',
            color: theme.palette.cms?.black || '#2f2f2f',
        },
    },
    panelDescription: {
        minHeight: '45px !important',
        padding: '0px !important',
        '& div': {
            margin: '16px 0px !important',
            textTransform: 'capitalize',
            padding: '0px !important',
            color: theme.palette.cms?.black || '#2f2f2f',
            fontWeight: 750,
            fontSize: '18px',
            lineHeight: '19px',
            display: 'flex',
            alignItems: 'center',

        },
    },
});

class LoginDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    handleChange =  (panel) => (event, expanded) => {
        if (expanded) {
            this.setState({ expanded: panel });
        } else {
            this.setState({ expanded: false });
        }
    }

    render() {
        const {
            classes, handleClose, getFullName, isAuthenticated, presentation_family, featureFlags,
        } = this.props;
        const { expanded } = this.state;
        const mobileIconsWithoutTextEnabled = featureFlags['is-mobile-icons-without-text'];

        const shortenFit = (s) => (s.length <= 6 ? s : `${s.substr(0, 6)}…`);
        if (isAuthenticated && presentation_family === 'flower') {
            return (
                <div className={classes.container}>

                    <ExpansionPanel className={classes.signIn} expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.panelDescription}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C10.3432 4 9.00003 5.34315 9.00003 7C9.00003 8.65685 10.3432 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7.00003 7C7.00003 4.23858 9.23861 2 12 2C14.7615 2 17 4.23858 17 7C17 9.76142 14.7615 12 12 12C9.23861 12 7.00003 9.76142 7.00003 7ZM4.46447 15.4645C5.40215 14.5268 6.67392 14 8 14H16C17.3261 14 18.5979 14.5268 19.5355 15.4645C20.4732 16.4021 21 17.6739 21 19V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19C19 18.2044 18.6839 17.4413 18.1213 16.8787C17.5587 16.3161 16.7956 16 16 16H8C7.20435 16 6.44129 16.3161 5.87868 16.8787C5.31607 17.4413 5 18.2043 5 19V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19C3 17.6739 3.52678 16.4021 4.46447 15.4645Z" fill="#2F363D" />
                            </svg>
                            {!mobileIconsWithoutTextEnabled && <> Hi&nbsp;{isAuthenticated &&  getFullName?.firstName !== '' ? shortenFit(getFullName.firstName) :  null} </>}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.panelDetails}>
                            <Link onClick={handleClose} to="/account">My Account</Link>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails className={classes.panelDetails}>
                            <a onClick={handleClose} href="/account/orders">My Orders</a>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails className={classes.panelDetails}>
                            <Link onClick={handleClose} to="/auth/logout">Sign Out</Link>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            );
        }
        return null;
    }
}
const mapStateToProps = (state) => ({
    getFullName: commonSelectors.getFirstLastName(state),
    isAuthenticated: commonSelectors.getIsAuthenticatedStatus(state),
    presentation_family: getPresentationFamily(state),
    featureFlags: getFeatureFlags(state),
});
LoginDropdown.propTypes = {
    classes: object.isRequired,
    handleClose: func.isRequired,
    presentation_family: string.isRequired,
    getFullName: shape({
        firstName: string.isRequired,
        lastName: string.isRequired,
    }).isRequired,
    isAuthenticated: bool.isRequired,
    featureFlags: object.isRequired,
};
export default connect(mapStateToProps, null)(withStyles(styles)(LoginDropdown));
